import { FeatureFlagKey } from '@/features/feature-flags/presentation/types/feature-flag-key';
import { Configuration } from './types';

export const config: Partial<Configuration> = {
  portalApi: 'https://ewa.api.dev.portal.genvis.com/v1',
  portalEwaBffApi: 'https://api.dev.portal.genvis.com/ewa/v1',
  remoteHazardAssets: {
    iconAssetsPathSvg: 'https://dev.kudo.genvis.com/assets/icons/map/pins',
    iconAssetsPathPng: 'https://dev.kudo.genvis.com/assets/icons/map/pins/40x40',
  },
  geospatialBucket: 'https://d1ro7pgfug9vfo.cloudfront.net',
  windTileBaseUrl: 'https://d32hjt8pptb5el.cloudfront.net/',
  externalTileBaseUrl: 'https://d3omvwfvh6ddq9.cloudfront.net',
  webTemplateStyleSheetUrl: 'https://dev.kudo.genvis.com/assets/styles/ewa-webtemplate.css',
  environment: 'local',
  mapbox: {
    defaultStyle: 'mapbox://styles/robgenvis/cmizqxrq9006201r81qml3b97',
    satelliteStyle: 'mapbox://styles/robgenvis/cmizqz3k4006301sn591b269u',
    overlaysTileSet: 'mapbox://robgenvis.ewa-overlays-dev',
    overlayTileSetLayers: {
      dfesRegions: 'dfes-regions-tileset-layer-dev',
      lga: 'lga-tileset-layer-dev',
      lgaCentres: 'lga-centres-tileset-layer-dev',
      pastoralStations: 'pastoral-stations-tileset-layer-dev',
      fdrRegions: 'fdr-regions-cr69-tileset-layer-dev',
      fdrCenters: 'fdr-centres-cr69-tileset-layer-dev',
    },
  },
  featureFlags: {
    [FeatureFlagKey.EnableMyEmergencyPlan]: true,
  },
  firebaseConfig: {
    apiKey: 'AIzaSyBIk_mAn8ACPEVLiHDQ_PHuafTxw6sc_QU',
    authDomain: 'ewa-web-dev.firebaseapp.com',
    projectId: 'ewa-web-dev',
    storageBucket: 'ewa-web-dev.firebasestorage.app',
    messagingSenderId: '475247624144',
    appId: '1:475247624144:web:f725e79024a35d5b97c3d5',
    measurementId: 'G-KS7PWWHYC0',
  },
  recaptcha: {
    siteKey: '6Lf73LwrAAAAAO3tA0h4uSB0qSNpyTbg2LHC1Ezj',
  },
  googleTagManager: {
    containerId: 'GTM-PZWL43P8',
  },
};
